import {
  AppBar,
  Box,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material';
import { forwardRef } from 'react';

import { PortalTheme } from '@frontend-libs/portal';

export interface AppHeaderProps {
  title: string;
  leftAction?: React.ReactNode;
  rightAction?: React.ReactNode;
  hideOnSmallScreens?: boolean;
}

export const AppHeader = forwardRef<HTMLElement, AppHeaderProps>(
  (props, ref) => {
    const theme = useTheme<PortalTheme>();
    return (
      <AppBar
        ref={ref}
        id="app-header"
        position="sticky"
        sx={{
          width: '100%',
          px: 2,
          pt: 'var(--safe-area-inset-top)',
          ...(props.hideOnSmallScreens && {
            [theme.breakpoints.down('sm')]: {
              display: 'none',
            },
          }),
        }}
      >
        <Toolbar
          sx={{
            justifyContent: 'center',
          }}
        >
          <Stack
            direction="row"
            sx={{
              width: '100%',
              alignItems: 'center',
              [theme.breakpoints.up('sm')]: {
                justifyContent: 'center',
                maxWidth: theme.contentMaxWidth,
              },
            }}
          >
            {props.leftAction && (
              <Box
                id="app-header-left-action"
                sx={{ position: 'absolute', left: 0 }}
              >
                {props.leftAction}
              </Box>
            )}

            {props.rightAction && (
              <Box
                id="app-header-right-action"
                sx={{ position: 'absolute', right: 0 }}
              >
                {props.rightAction}
              </Box>
            )}

            {props.title && (
              <Typography
                data-testid="app-header-title"
                id="app-header-title"
                variant="h6"
                component="h1"
                textAlign="center"
                width="100%"
              >
                {props.title}
              </Typography>
            )}
          </Stack>
        </Toolbar>
      </AppBar>
    );
  },
);
